import { useState } from "react";
import type { Faq } from "@/types/content";
import { useSiteData } from "@/context/SiteDataContext";
import { mergeFaqConfig } from "@/lib/faqConfig";

export default function FAQAccordion({ items }: { items: Faq[] }) {
  const { data } = useSiteData();
  const { primera_abierta } = mergeFaqConfig(data.contentBlocks.home?.faq_config?.[0]);
  const [openId, setOpenId] = useState<number | null>(primera_abierta ? (items[0]?.id ?? null) : null);

  return (
    <div className="divide-y divide-background-200 border border-background-200 rounded-lg bg-background-50 overflow-hidden">
      {items.map((item) => {
        const open = openId === item.id;
        return (
          <div key={item.id}>
            <button
              type="button"
              onClick={() => setOpenId(open ? null : item.id)}
              className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-5 text-left cursor-pointer transition hover:bg-background-100"
              aria-expanded={open}
            >
              <span className="font-heading font-semibold text-foreground-900 text-sm md:text-base">
                {item.pregunta}
              </span>
              <span className="w-6 h-6 shrink-0 rounded-full bg-background-200 text-foreground-700 flex items-center justify-center">
                <i className={`text-base transition-transform ${open ? "rotate-45" : ""} ri-add-line`} />
              </span>
            </button>
            <div
              className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
            >
              <div className="overflow-hidden">
                <p className="px-5 md:px-6 pb-5 text-sm md:text-base text-foreground-600 leading-relaxed">
                  {item.respuesta}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}